import React from 'react'
import { useMutation, useQuery } from '@apollo/client'
import {
  QUERY_STORE_STRIPE_CONNECT_URL,
  DISCONNECT_STORE_STRIPE_SETTINGS
} from '../Settings/actions'
import { Store } from '@slerp/controls'
import { StripeConnect } from '../Utils/Stripe'
import { STRIPE_CONNECT_LOCATION_OAUTH_ENDPOINT } from '@slerp/client'
import { useStripeDisconnect } from 'components/Common'

interface Props {
  store: Store
  stripeId: string
  canConnect: boolean
}

const StripeConnectSettings = ({ canConnect, store, stripeId }: Props) => {
  const redirect_uri = STRIPE_CONNECT_LOCATION_OAUTH_ENDPOINT

  const {
    data,
    loading: connectLoading,
    refetch
  } = useQuery(QUERY_STORE_STRIPE_CONNECT_URL, {
    variables: {
      redirectUri: redirect_uri,
      storeId: store.id
    },
    fetchPolicy: 'no-cache'
  })

  const [disconnectStoreStripeSettings] = useMutation(
    DISCONNECT_STORE_STRIPE_SETTINGS,
    { fetchPolicy: 'no-cache' }
  )

  const { modals, openConfirm, disconnecting } = useStripeDisconnect({
    disconnect: () =>
      disconnectStoreStripeSettings({ variables: { storeId: store.id } }),
    onSuccess: refetch,
    invoicesPath: `/location/${store.slug}/settings/accounts-and-billing/invoices`
  })

  const handleConnect = () => {
    localStorage.setItem(
      'redirect-store',
      JSON.stringify({ id: store.id, slug: store.slug })
    )
  }

  return (
    <>
      <StripeConnect
        loading={connectLoading}
        stripeId={stripeId}
        isAllowed={canConnect}
        hasStripeCustomerId={canConnect}
        stripeConnectUrl={data?.storeStripeConnectUrl}
        onConnect={handleConnect}
        onDisconnect={openConfirm}
        disconnecting={disconnecting}
      />
      {modals}
    </>
  )
}

export default StripeConnectSettings
